module.exports = __webpack_public_path__ + "img/icon_map_1_off_001.2c98b42e.png";